import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Quote from '@/components/material-ui-kit/components/Typography/Quote';
import styles from 'styles/jss/original/components/menus/detailQuote';
import { IMenu } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailQuote: React.FC<ComponentProps> = ({ menu }) => {
  const classes = useStyles();
  const { quote } = menu.fields;

  if (!quote) return null;
  return (
    <div className={classes.container}>
      <div className={classes.textQuote}>
        <Quote text={quote} />
      </div>
    </div>
  );
};

export default DetailQuote;
